import { createStyles, withStyles } from '@material-ui/styles';
import classNames from 'classnames';
import * as React from 'react';
import { compose, pure, withHandlers, withState } from 'recompose';
import { FontIcon } from '../FontIcon';
import { Text } from '../Text';
import Popover from './Popover';
const styles = (theme) => createStyles({
    morePopoverContainer: {
        display: 'flex',
        flexDirection: 'column',
        background: theme.color.grey.dark,
        borderRadius: theme.common.borderRadius.default,
        '& Button': {
            borderRadius: 1,
            minWidth: 150,
            height: 40,
            color: theme.color.font.light,
            justifyContent: 'flex-start',
            textTransform: 'none',
            fontWeight: theme.font.weight.light,
            '&:hover': {
                backgroundColor: theme.color.grey.darkest,
                fontWeight: theme.font.weight.normal,
            },
        },
    },
    buttonContainer: {
        display: 'grid',
        gridAutoFlow: 'column',
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
        },
    },
});
const MorePopover = (props) => {
    const { children, classes, className, clickableComponent, testId = 'MorePopover', disableRestoreFocus } = props;
    return (React.createElement(Popover, { autoCloseOnClick: true, clickableComponent: clickableComponent, disableRestoreFocus: disableRestoreFocus, position: "bottomRight", "data-testid": `${testId}` },
        React.createElement("div", { "data-testid": `${testId}-content`, className: classNames(classes.morePopoverContainer, className) }, children)));
};
const ComposedMorePopover = compose(withState('open', 'setOpen', false), withStyles(styles, { withTheme: true }), pure, withHandlers({
    clickableComponent: ({ classes, labelButton, iconSize, iconName, fromMui, iconColor, testId = 'MorePopover', }) => ({ setOpen, open }) => (React.createElement("div", { onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpen(!open);
        }, "data-testid": `${testId}-toggle`, className: classes.buttonContainer },
        React.createElement(FontIcon, { iconName: iconName || 'more', fromMui: fromMui, color: iconColor || 'black', size: iconSize || 20, top: 3 }),
        labelButton && React.createElement(Text, null, labelButton))),
}))(MorePopover);
ComposedMorePopover.displayName = 'MorePopover';
export default ComposedMorePopover;
//# sourceMappingURL=MorePopover.js.map